import React, { Component } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import logoSm from "../../assets/images/nexion_sm.png";
import i18next from "i18next";
import { MetaTags } from "react-meta-tags";
import { Sugar } from "react-preloaders";
import { withTranslation } from "react-i18next";
import config from "./../../helpers/Constants";
import LoadingOverlay from "react-loading-overlay";
import moment from "moment";

class DashboardReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: localStorage.getItem("lang"),
      loading: true,
      isActive: true,
      curr_date: "",
      diag_ac_user_count: 0,
      diagnosis_count: 0,
      ver_ac_user_count: 0,
      ver_count: 0,
      diag_brand_list: [],
      diag_brand_item: [],
      diag_model_list: [],
      diag_model_item: [],
      diag_ecu_list: [],
      diag_ecu_item: [],
      diag_lang_list: [],
      diag_lang_item: [],
      diag_location_count: [],
      diag_location_list: [],
      diag_location_item: [],
      diag_location_array: [],
      ver_location_array: [],
      ver_location_count: [],
      diag_tester_list: [],
      diag_tester_item: [],
      ver_tester_list: [],
      ver_tester_item: [],
      ver_lang_list: [],
      ver_lang_item: [],
      ver_ac_password: 0,
      ver_exp_password: 0,
      ver_tester_undefined_div: 0,
      ver_tester_android_div: 0,
      ver_tester_windows_div: 0,
      ver_tester_ap_undefined_div: 0,
      ver_tester_ap_android_div: 0,
      ver_tester_ap_windows_div: 0,
      ver_tester_total_div: 0,
      ver_tester_ap_total_div: 0,
      ver_tester_undefined_ione: 0,
      ver_tester_android_ione: 0,
      ver_tester_windows_ione: 0,
      ver_tester_total_ione: 0,
      ver_tester_ap_undefined_ione: 0,
      ver_tester_ap_android_ione: 0,
      ver_tester_ap_windows_ione: 0,
      ver_tester_ap_total_ione: 0,
      daysvalue: localStorage.getItem("data_visible_days"),
      diag_au_daysvalue: "",
      diag_daysvalue: "",
      diag_brands_daysvalue: "",
      diag_models_daysvalue: "",
      diag_lang_daysvalue: "",
      diag_ecu_daysvalue: "",
      diag_map_daysvalue: "",
      diag_tester_daysvalue: "",
      ver_au_daysvalue: "",
      ver_daysvalue: "",
      ver_map_daysvalue: "",
      ver_tester_daysvalue: "",
      ver_tester_d_daysvalue: "",
      ver_tester_ap_daysvalue: "",
      ver_ap_daysvalue: "",
      ver_lang_daysvalue: "",
      loading: true,
      sum_ac_user_count: 0,
      sum_au_daysvalue: "",
      sum_ac_password: 0,
      sum_exp_password: 0,
      sum_ap_daysvalue: "",
      sum_all_ac_password: 0,
      sum_all_exp_password: 0,
      sum_all_ap_daysvalue: "",
      sum_os_windows: 0,
      sum_os_android: 0,
      sum_os_undefined: 0,
      sum_os_daysvalue: "",
      sum_all_ap_total: 0,
      sum_os_total: 0,
    };
    i18next.changeLanguage(localStorage.getItem("lang"));
  }

  componentDidMount() {
    let decodedString = localStorage.getItem("authUser");
    let authUser = JSON.parse(atob(decodedString));
    var user_id = authUser.id;
    var data_visible_days = localStorage.getItem("data_visible_days");
    this.setState({
      diag_au_daysvalue: data_visible_days,
      diag_daysvalue: data_visible_days,
      diag_brands_daysvalue: data_visible_days,
      diag_map_daysvalue: data_visible_days,
      diag_tester_daysvalue: data_visible_days,
      ver_au_daysvalue: data_visible_days,
      ver_daysvalue: data_visible_days,
      ver_map_daysvalue: data_visible_days,
      ver_tester_daysvalue: data_visible_days,
      ver_tester_d_daysvalue: data_visible_days,
      ver_tester_ap_daysvalue: data_visible_days,
      ver_ap_daysvalue: data_visible_days,
      ver_lang_daysvalue: data_visible_days,
      diag_models_daysvalue: data_visible_days,
      diag_lang_daysvalue: data_visible_days,
      diag_ecu_daysvalue: data_visible_days,
      sum_os_windows: 0,
      sum_os_android: 0,
      sum_os_undefined: 0,
      sum_os_daysvalue: "",
      sum_all_ap_total: 0,
      sum_os_total: 0,
      sum_au_daysvalue: data_visible_days,
      sum_ap_daysvalue: data_visible_days,
      sum_all_ap_daysvalue: data_visible_days,
      sum_os_daysvalue: data_visible_days,
      curr_date: moment().format("DD-MM-YYYY hh:mm:ss"),
    });

    if (!data_visible_days) {
      var day = "14";
    } else {
      day = data_visible_days;
    }

    const selected_product = localStorage.getItem("sel_product");
    const user_language = localStorage.getItem("user_db_lang");

    if (!selected_product) {
      var sel_product = "all";
    } else {
      var sel_product = selected_product;
    }

    const data_source = localStorage.getItem("data_source");

    fetch(config.API + "get_user_permissions/" + user_id, {
      headers: {
        Nexion_API_Key: config.API_KEY,
      },
    })
      .then((Responses) => Responses.json())
      .then((findresponses) => {
        this.setState({
          loading: false,
        });
        if (findresponses.users === 0) {
          window.history.back();
        }
      });

    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_active_users/";
    } else {
      var data_source_final = "get_dashboard_active_users/";
    }

    //diag active users
    fetch(
      config.API +
        // "get_dashboard_active_users/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        this.setState({
          diag_ac_user_count: findresponse.diag_count,
        });
      });

    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis/";
    } else {
      var data_source_final = "get_dashboard_diagnosis/";
    }

    //diagnosis count
    var days = localStorage.getItem("data_visible_days");
    var diagnosis_count;
    fetch(
      config.API +
        // "get_dashboard_diagnosis/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        // console.log(findresponse);
        diagnosis_count = findresponse.diag_count;
        this.setState({
          diag_count: findresponse.diag_count,
        });
      })
      .then(() => {
        //diagnosis location count
        var days = localStorage.getItem("data_visible_days");
        if (data_source === "internal") {
          var data_source_final = "test_get_dashboard_diagnosis_location/";
        } else {
          var data_source_final = "get_dashboard_diagnosis_location/";
        }

        fetch(
          config.API +
            // "get_dashboard_diagnosis_location/" +
            data_source_final +
            day +
            "?company=Nexion&sel_product=" +
            sel_product +
            "&user_lang=" +
            user_language,
          {
            headers: {
              Nexion_API_Key: config.API_KEY,
            },
          }
        )
          .then((Response) => Response.json())
          .then((findresponse) => {
            var old_total_count = findresponse
              .map((item) => item.diagnosis_count)
              .reduce((prev, next) => prev + next, 0);
            let diag_undef = diagnosis_count - old_total_count;
            let new_loc_array = {
              diagnosis_count: diag_undef,
              country_name: "Undefined",
            };
            findresponse.push(new_loc_array);

            var new_total_count = findresponse
              .map((item) => item.diagnosis_count)
              .reduce((prev, next) => prev + next);

            this.setState({
              diag_location_count: new_total_count,
              diag_map_daysvalue: days,
              diag_location_array: findresponse,
            });
          });
      });

    //diagnosis brands
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis_brands/";
    } else {
      var data_source_final = "get_dashboard_diagnosis_brands/";
    }

    fetch(
      config.API +
        // "get_dashboard_diagnosis_brands/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          diag_brand_list: findresponse.brands.b_list,
          diag_brand_item: findresponse.brands.b_items,
        });
      });

    //diagnosis Models
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis_models/";
    } else {
      var data_source_final = "get_dashboard_diagnosis_models/";
    }

    fetch(
      config.API +
        // "get_dashboard_diagnosis_models/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          diag_model_list: findresponse.models.b_list,
          diag_model_item: findresponse.models.b_items,
        });
      });

    //diagnosis Ecus
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis_ecu/";
    } else {
      var data_source_final = "get_dashboard_diagnosis_ecu/";
    }

    fetch(
      config.API +
        // "get_dashboard_diagnosis_ecu/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&lang=" +
        localStorage.getItem("lang") +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          diag_ecu_list: findresponse.models.b_list,
          diag_ecu_item: findresponse.models.b_items,
        });
      });

    //diagnosis Lang
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis_lang/";
    } else {
      var data_source_final = "get_dashboard_diagnosis_lang/";
    }

    fetch(
      config.API +
        // "get_dashboard_diagnosis_lang/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          diag_lang_list: findresponse.languages.b_list,
          diag_lang_item: findresponse.languages.b_items,
        });
      });

    //Version Lang
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_lang/";
    } else {
      var data_source_final = "get_dashboard_version_lang/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_lang/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          ver_lang_list: findresponse.languages.b_list,
          ver_lang_item: findresponse.languages.b_items,
        });
      });

    //Version Active Password
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_ap/";
    } else {
      var data_source_final = "get_dashboard_version_ap/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_ap/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse);
        this.setState({
          ver_ac_password: findresponse.ac_password,
          ver_exp_password: findresponse.exp_password,
        });
      });

    //version count
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_versions/";
    } else {
      var data_source_final = "get_dashboard_versions/";
    }

    var version_count;
    fetch(
      config.API +
        // "get_dashboard_versions/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        // console.log(findresponse);
        version_count = findresponse.ver_count;
        this.setState({
          ver_count: findresponse.ver_count,
        });
      })
      .then(() => {
        //version location count
        if (data_source === "internal") {
          var data_source_final = "test_get_dashboard_version_location/";
        } else {
          var data_source_final = "get_dashboard_version_location/";
        }

        fetch(
          config.API +
            // "get_dashboard_version_location/" +
            data_source_final +
            day +
            "?company=Nexion&sel_product=" +
            sel_product +
            "&user_lang=" +
            user_language,
          {
            headers: {
              Nexion_API_Key: config.API_KEY,
            },
          }
        )
          .then((Response) => Response.json())
          .then((findresponse) => {
            var old_total_count = findresponse
              .map((item) => item.diagnosis_count)
              .reduce((prev, next) => prev + next, 0);

            let ver_undef = version_count - old_total_count;
            let new_loc_array = {
              diagnosis_count: ver_undef,
              country_name: "Undefined",
            };
            findresponse.push(new_loc_array);

            var new_total_count = findresponse
              .map((item) => item.diagnosis_count)
              .reduce((prev, next) => prev + next, 0);

            this.setState({
              ver_location_count: new_total_count,
              ver_map_daysvalue: days,
              ver_location_array: findresponse,
            });
          });
      });

    //version ac user count
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_active_users/";
    } else {
      var data_source_final = "get_dashboard_version_active_users/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_active_users/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        // console.log(findresponse);
        this.setState({
          ver_ac_user_count: findresponse.ver_count,
        });
      });

    //Diagnosis Tester
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_diagnosis_tester/";
    } else {
      var data_source_final = "get_dashboard_diagnosis_tester/";
    }

    fetch(
      config.API +
        // "get_dashboard_diagnosis_tester/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        // console.log(findresponse);
        this.setState({
          diag_tester_list: findresponse.testers.t_list,
          diag_tester_item: findresponse.testers.t_items,
        });
      });

    //Version Tester
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_tester/";
    } else {
      var data_source_final = "get_dashboard_version_tester/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_tester/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        // console.log(findresponse);
        this.setState({
          ver_tester_list: findresponse.testers.t_list,
          ver_tester_item: findresponse.testers.t_items,
        });
      });

    //Version Tester Div.0 distribution
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_tester_os_div/";
    } else {
      var data_source_final = "get_dashboard_version_tester_os_div/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_tester_os_div/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse[2].total);

        if (findresponse[0].total) {
          this.setState({
            ver_tester_undefined_div: findresponse[0].total,
          });
        } else {
          this.setState({
            ver_tester_undefined_div: 0,
          });
        }

        if (findresponse[1].total) {
          this.setState({
            ver_tester_android_div: findresponse[1].total,
          });
        } else {
          this.setState({
            ver_tester_android_div: 0,
          });
        }

        if (findresponse[2].total) {
          this.setState({
            ver_tester_windows_div: findresponse[2].total,
          });
        } else {
          this.setState({
            ver_tester_windows_div: 0,
          });
        }
        this.setState({
          ver_tester_total_div:
            findresponse[0].total +
            findresponse[1].total +
            findresponse[2].total,
        });
      });

    //Version Tester iONE Cruiser distribution
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_tester_ione/";
    } else {
      var data_source_final = "get_dashboard_version_tester_ione/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_tester_os_ione/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse[2].total);

        if (findresponse[0].total) {
          this.setState({
            ver_tester_undefined_ione: findresponse[0].total,
          });
        } else {
          this.setState({
            ver_tester_undefined_ione: 0,
          });
        }

        if (findresponse[1].total) {
          this.setState({
            ver_tester_android_ione: findresponse[1].total,
          });
        } else {
          this.setState({
            ver_tester_android_ione: 0,
          });
        }

        if (findresponse[2].total) {
          this.setState({
            ver_tester_windows_ione: findresponse[2].total,
          });
        } else {
          this.setState({
            ver_tester_windows_ione: 0,
          });
        }
        this.setState({
          ver_tester_total_ione:
            findresponse[0].total +
            findresponse[1].total +
            findresponse[2].total,
        });
      });

    //Version Tester Div.0 distribution Active Password
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_tester_os_ap_div/";
    } else {
      var data_source_final = "get_dashboard_version_tester_os_ap_div/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_tester_os_ap_div/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse[1].total);

        if (findresponse[0].total) {
          this.setState({
            ver_tester_ap_undefined_div: findresponse[0].total,
          });
        } else {
          this.setState({
            ver_tester_ap_undefined_div: 0,
          });
        }

        if (findresponse[1].total) {
          this.setState({
            ver_tester_ap_android_div: findresponse[1].total,
          });
        } else {
          this.setState({
            ver_tester_ap_android_div: 0,
          });
        }

        if (findresponse[2].total) {
          this.setState({
            ver_tester_ap_windows_div: findresponse[2].total,
          });
        } else {
          this.setState({
            ver_tester_ap_windows_div: 0,
          });
        }

        this.setState({
          ver_tester_ap_total_div:
            findresponse[0].total +
            findresponse[1].total +
            findresponse[2].total,
        });
      });

    //Version Tester Ione distribution Active Password
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_version_tester_os_ap_ione/";
    } else {
      var data_source_final = "get_dashboard_version_tester_os_ap_ione/";
    }

    fetch(
      config.API +
        // "get_dashboard_version_tester_os_ap_ione/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        //console.log(findresponse[1].total);

        if (findresponse[0].total) {
          this.setState({
            ver_tester_ap_undefined_ione: findresponse[0].total,
          });
        } else {
          this.setState({
            ver_tester_ap_undefined_ione: 0,
          });
        }

        if (findresponse[1].total) {
          this.setState({
            ver_tester_ap_android_ione: findresponse[1].total,
          });
        } else {
          this.setState({
            ver_tester_ap_android_ione: 0,
          });
        }

        if (findresponse[2].total) {
          this.setState({
            ver_tester_ap_windows_ione: findresponse[2].total,
          });
        } else {
          this.setState({
            ver_tester_ap_windows_ione: 0,
          });
        }

        this.setState({
          ver_tester_ap_total_ione:
            findresponse[0].total +
            findresponse[1].total +
            findresponse[2].total,
        });
      });

    //Sum All user count
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_sum_active_users/";
    } else {
      var data_source_final = "get_dashboard_sum_active_users/";
    }

    fetch(
      config.API +
        // "get_dashboard_sum_active_users/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        this.setState({
          sum_ac_user_count: findresponse.diag_count,
        });
      });

    //Sum Active Password
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_sum_ap/";
    } else {
      var data_source_final = "get_dashboard_sum_ap/";
    }

    fetch(
      config.API +
        // "get_dashboard_sum_ap/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        this.setState({
          sum_ac_password: findresponse.ac_password,
          sum_exp_password: findresponse.exp_password,
        });
      });

    //Sum All Active Password
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_sum_all_ap/";
    } else {
      var data_source_final = "get_dashboard_sum_all_ap/";
    }

    fetch(
      config.API +
        // "get_dashboard_sum_all_ap/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        this.setState({
          sum_all_ac_password: findresponse.ac_password,
          sum_all_exp_password: findresponse.exp_password,
        });
        this.setState({
          sum_all_ap_total:
            findresponse.ac_password + findresponse.exp_password,
        });
      });

    //Sum OS Type
    if (data_source === "internal") {
      var data_source_final = "test_get_dashboard_sum_os/";
    } else {
      var data_source_final = "get_dashboard_sum_os/";
    }

    fetch(
      config.API +
        // "get_dashboard_sum_os/" +
        data_source_final +
        day +
        "?company=Nexion&sel_product=" +
        sel_product +
        "&user_lang=" +
        user_language,
      {
        headers: {
          Nexion_API_Key: config.API_KEY,
        },
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        if (findresponse[0].total) {
          this.setState({
            sum_os_undefined: findresponse[0].total,
          });
        } else {
          this.setState({
            sum_os_undefined: 0,
          });
        }

        if (findresponse[2].total) {
          this.setState({
            sum_os_windows: findresponse[2].total,
          });
        } else {
          this.setState({
            sum_os_windows: 0,
          });
        }

        if (findresponse[1].total) {
          this.setState({
            sum_os_android: findresponse[1].total,
          });
        } else {
          this.setState({
            sum_os_android: 0,
          });
        }
        this.setState({
          sum_os_total:
            findresponse[0].total +
            findresponse[1].total +
            findresponse[2].total,
        });
      });
  }

  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <MetaTags>
          <title>Dashboard Report | Nexion Engineering Web Portal</title>
          <meta
            name="description"
            content="Diagnostic Portal For Technomotor and Magneti Marelli Instruments"
          />
        </MetaTags>
        <Sugar
          customLoading={this.state.loading}
          background="#016362"
          color={"#ffffff"}
        />
        <div className="container-fluid">
          <Row className="align-items-center">
            <Col sm={6}>
              <div className="page-title-box"></div>
            </Col>
          </Row>

          <Row>
            <div className="col-1"></div>
            <div className="col-10 report_class">
              <Card>
                <CardBody className="report_card">
                  <Row>
                    <div className="col-12">
                      <Row>
                        <div className="col-8">
                          <h2 className="font-size-20">
                            <i class="mdi mdi-jira jira_report"></i>DIAGNOSIS
                            DASHBOARD REPORT
                          </h2>
                          <p>
                            <b>Report Date:</b> {this.state.curr_date}
                          </p>
                        </div>
                        <div className="col-4">
                          <div className="invoice-title">
                            <img
                              src={logoSm}
                              className="float-right"
                              alt="logo"
                              height="50"
                            />
                          </div>
                        </div>
                      </Row>
                      <hr />
                    </div>
                  </Row>

                  <Row>
                    <div className="col-12">
                      <div>
                        <strong>
                          <h5> {t("homepage.summary")}: </h5>
                        </strong>
                        <br />
                        <div>
                          <strong>
                            {t("homepage.sum_ac_user_count")}:{" "}
                            {this.state.sum_ac_user_count}
                          </strong>
                        </div>
                      </div>
                      <Row>
                        <Col xl={6} sm={6}>
                          <div>
                            <br />
                            <div className="p-2">
                              <strong>
                                {t("homepage.sum_active_password")}
                              </strong>
                            </div>
                            <div className="">
                              <div className="table-responsive">
                                <table className="table table-sm m-0 rep-table-bordered">
                                  <thead>
                                    <tr>
                                      <td className="text-center">
                                        <strong>
                                          {t("homepage.active_password")}
                                        </strong>
                                      </td>
                                      <td className="text-center">
                                        <strong>
                                          {t("homepage.expired_password")}
                                        </strong>
                                      </td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="text-center">
                                        {this.state.sum_ac_password}
                                      </td>
                                      <td className="text-center">
                                        {this.state.sum_exp_password}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col xl={6} sm={6}>
                          <div>
                            <br />
                            <div className="p-2">
                              <strong>
                                {t("homepage.sum_all_active_password")}
                              </strong>
                            </div>
                            <div className="">
                              <div className="table-responsive">
                                <table className="table table-sm m-0 rep-table-bordered">
                                  <thead>
                                    <tr>
                                      <td className="text-center">
                                        <strong>
                                          {t("homepage.active_password")}
                                        </strong>
                                      </td>
                                      <td className="text-center">
                                        <strong>
                                          {t("homepage.expired_password")}
                                        </strong>
                                      </td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="text-center">
                                        {this.state.sum_all_ac_password}
                                      </td>
                                      <td className="text-center">
                                        {this.state.sum_all_exp_password}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <div>
                        <br />
                        <div>
                          <strong>{t("homepage.sum_os")}</strong>
                        </div>
                        <div className="">
                          <div className="table-responsive">
                            <table className="table table-sm m-0 rep-table-bordered">
                              <thead>
                                <tr>
                                  <td className="text-center">
                                    <strong>Windows</strong>
                                  </td>
                                  <td className="text-center">
                                    <strong>Android</strong>
                                  </td>
                                  <td className="text-center">
                                    <strong>Undefined</strong>
                                  </td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="text-center">
                                    {this.state.sum_os_windows}
                                  </td>
                                  <td className="text-center">
                                    {this.state.sum_os_android}
                                  </td>
                                  <td className="text-center">
                                    {this.state.sum_os_undefined}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <br />
                      <hr />
                      <div>
                        <div>
                          <strong>
                            <h5> DIAGNOSIS: </h5>
                          </strong>
                        </div>
                        <div className="">
                          <div className="table-responsive">
                            <table className="table table-sm m-0 rep-table-bordered">
                              <thead>
                                <tr>
                                  <td className="text-center">
                                    <strong>
                                      {t("homepage.active_users")}
                                    </strong>
                                  </td>
                                  <td className="text-center">
                                    <strong>{t("homepage.diagnosis")}</strong>
                                  </td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="text-center">
                                    {this.state.diag_ac_user_count}
                                  </td>
                                  <td className="text-center">
                                    {this.state.diag_count}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <br />
                        <Row>
                          <Col xl={6} sm={6}>
                            <div className="">
                              <strong>
                                <h6> {t("homepage.brands")} </h6>
                              </strong>
                              <div className="table-responsive">
                                <table className="table table-sm m-0 rep-table-bordered">
                                  {this.state.diag_brand_list.map(
                                    (brand, index) => {
                                      return (
                                        <tr>
                                          <th className="text-left">
                                            <strong>{brand}</strong>
                                          </th>
                                          <td className="text-left">
                                            {this.state.diag_brand_item[index]}
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </table>
                              </div>
                            </div>
                          </Col>
                          <Col xl={6} sm={6}>
                            <div className="">
                              <strong>
                                <h6> {t("homepage.models")} </h6>
                              </strong>
                              <div className="table-responsive">
                                <table className="table table-sm m-0 rep-table-bordered">
                                  {this.state.diag_model_list.map(
                                    (model, index) => {
                                      return (
                                        <tr>
                                          <th className="text-left">
                                            <strong>{model}</strong>
                                          </th>
                                          <td className="text-left">
                                            {this.state.diag_model_item[index]}
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </table>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <br />
                        <br />
                        <Row>
                          <Col xl={6} sm={6}>
                            <div className="">
                              <strong>
                                <h6> PLANTS </h6>
                              </strong>
                              <div className="table-responsive">
                                <table className="table table-sm m-0 rep-table-bordered">
                                  {this.state.diag_ecu_list.map(
                                    (ecu, index) => {
                                      return (
                                        <tr>
                                          <th className="text-left">
                                            <strong>{ecu}</strong>
                                          </th>
                                          <td className="text-left">
                                            {this.state.diag_ecu_item[index]}
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </table>
                              </div>
                            </div>
                          </Col>
                          <Col xl={6} sm={6}>
                            <div className="">
                              <strong>
                                <h6> {t("homepage.languages")} </h6>
                              </strong>
                              <div className="table-responsive">
                                <table className="table table-sm m-0 rep-table-bordered">
                                  {this.state.diag_lang_list.map(
                                    (lang, index) => {
                                      return (
                                        <tr>
                                          <th className="text-left">
                                            <strong>{lang}</strong>
                                          </th>
                                          <td className="text-left">
                                            {this.state.diag_lang_item[index]}
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </table>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <br />
                        <br />
                        <Row>
                          <Col xl={6} sm={6}>
                            <div className="">
                              <strong>
                                <h6> {t("homepage.countries")} </h6>
                              </strong>
                              <div className="table-responsive">
                                <table className="table table-sm m-0 rep-table-bordered">
                                  {this.state.diag_location_array.map(
                                    (item) => {
                                      return (
                                        <tr>
                                          <th className="text-left">
                                            <strong>{item.country_name}</strong>
                                          </th>
                                          <td className="text-left">
                                            {item.diagnosis_count}
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </table>
                              </div>
                            </div>
                          </Col>
                          <Col xl={6} sm={6}>
                            <div className="">
                              <strong>
                                <h6> {t("homepage.tester_type")} </h6>
                              </strong>
                              <div className="table-responsive">
                                <table className="table table-sm m-0 rep-table-bordered">
                                  <thead>
                                    <tr>
                                      <td className="text-center">
                                        <strong>Div.0</strong>
                                      </td>
                                      <td className="text-center">
                                        <strong>iONE Cruiser</strong>
                                      </td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="text-center">
                                        {this.state.diag_tester_item[0]}
                                      </td>
                                      <td className="text-center">
                                        {this.state.diag_tester_item[1]}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <br />
                        <br />
                        <Row>
                          <Col xl={6} sm={6}>
                            <div className="">
                              <strong>
                                <h6>
                                  {" "}
                                  {t(
                                    "homepage.tester_type_distribution_overall"
                                  )}{" "}
                                </h6>
                              </strong>
                              <div className="table-responsive">
                                <table className="table table-sm m-0 rep-table-bordered">
                                  <thead>
                                    <tr>
                                      <td className="text-center">
                                        <strong>Windows</strong>
                                      </td>
                                      <td className="text-center">
                                        <strong>Android</strong>
                                      </td>
                                      <td className="text-center">
                                        <strong>Undefined</strong>
                                      </td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="text-center">
                                        {this.state.ver_tester_windows_div +
                                          this.state.ver_tester_windows_ione}
                                      </td>
                                      <td className="text-center">
                                        {this.state.ver_tester_android_div +
                                          this.state.ver_tester_android_ione}
                                      </td>
                                      <td className="text-center">
                                        {this.state.ver_tester_undefined_div +
                                          this.state.ver_tester_undefined_ione}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </Col>
                          <Col xl={6} sm={6}>
                            <div className="">
                              <strong>
                                <h6>
                                  {" "}
                                  {t(
                                    "homepage.tester_type_distribution_with_active_password"
                                  )}{" "}
                                </h6>
                              </strong>
                              <div className="table-responsive">
                                <table className="table table-sm m-0 rep-table-bordered">
                                  <thead>
                                    <tr>
                                      <td className="text-center">
                                        <strong>Windows</strong>
                                      </td>
                                      <td className="text-center">
                                        <strong>Android</strong>
                                      </td>
                                      <td className="text-center">
                                        <strong>Undefined</strong>
                                      </td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="text-center">
                                        {this.state.ver_tester_ap_windows_div +
                                          this.state.ver_tester_ap_windows_ione}
                                      </td>
                                      <td className="text-center">
                                        {this.state.ver_tester_ap_android_div +
                                          this.state.ver_tester_ap_android_ione}
                                      </td>
                                      <td className="text-center">
                                        {this.state
                                          .ver_tester_ap_undefined_div +
                                          this.state
                                            .ver_tester_ap_undefined_ione}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      {/* Versions */}
                      <br />
                      <hr />
                      <div>
                        <div>
                          <strong>
                            <h5> VERSION: </h5>
                          </strong>
                        </div>
                        <div className="">
                          <div className="table-responsive">
                            <table className="table table-sm m-0 rep-table-bordered">
                              <thead>
                                <tr>
                                  <td className="text-center">
                                    <strong>
                                      {t("homepage.ver_active_users")}
                                    </strong>
                                  </td>
                                  <td className="text-center">
                                    <strong>
                                      {t("homepage.dash_version")}
                                    </strong>
                                  </td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="text-center">
                                    {this.state.ver_ac_user_count}
                                  </td>
                                  <td className="text-center">
                                    {this.state.ver_count}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <br />
                        <Row>
                          <Col xl={6} sm={6}>
                            <div className="">
                              <strong>
                                <h6> {t("homepage.active_password")} </h6>
                              </strong>
                              <div className="table-responsive">
                                <table className="table table-sm m-0 rep-table-bordered">
                                  <thead>
                                    <tr>
                                      <td className="text-center">
                                        <strong>
                                          {t("homepage.active_password")}
                                        </strong>
                                      </td>
                                      <td className="text-center">
                                        <strong>
                                          {t("homepage.expired_password")}
                                        </strong>
                                      </td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="text-center">
                                        {this.state.ver_ac_password}
                                      </td>
                                      <td className="text-center">
                                        {this.state.ver_exp_password}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </Col>
                          <Col xl={6} sm={6}>
                            <div className="">
                              <strong>
                                <h6> {t("homepage.languages")} </h6>
                              </strong>
                              <div className="table-responsive">
                                <table className="table table-sm m-0 rep-table-bordered">
                                  {this.state.ver_lang_list.map(
                                    (lang, index) => {
                                      return (
                                        <tr>
                                          <th className="text-left">
                                            <strong>{lang}</strong>
                                          </th>
                                          <td className="text-left">
                                            {this.state.ver_lang_item[index]}
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </table>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <br />
                        <br />
                        <Row>
                          <Col xl={6} sm={6}>
                            <div className="">
                              <strong>
                                <h6> {t("homepage.countries")} </h6>
                              </strong>
                              <div className="table-responsive">
                                <table className="table table-sm m-0 rep-table-bordered">
                                  {this.state.ver_location_array.map((item) => {
                                    return (
                                      <tr>
                                        <th className="text-left">
                                          <strong>{item.country_name}</strong>
                                        </th>
                                        <td className="text-left">
                                          {item.diagnosis_count}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </table>
                              </div>
                            </div>
                          </Col>
                          <Col xl={6} sm={6}>
                            <div className="">
                              <strong>
                                <h6> {t("homepage.tester_type_ver")} </h6>
                              </strong>
                              <div className="table-responsive">
                                <table className="table table-sm m-0 rep-table-bordered">
                                  <thead>
                                    <tr>
                                      <td className="text-center">
                                        <strong>Div.0</strong>
                                      </td>
                                      <td className="text-center">
                                        <strong>iONE Cruiser</strong>
                                      </td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="text-center">
                                        {this.state.ver_tester_item[0]}
                                      </td>
                                      <td className="text-center">
                                        {this.state.ver_tester_item[1]}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      {/* Final Table with print Button */}
                      <div>
                        <div className="">
                          <br />
                          <div className="d-print-none">
                            <div className="float-right">
                              <Link
                                to="#"
                                onClick={() => {
                                  window.print();
                                }}
                                className="btn btn-mm waves-effect waves-light"
                              >
                                <i className="fa fa-print"> Stampa Report</i>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Row>
                </CardBody>
              </Card>
            </div>
            <div className="col-1"></div>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(DashboardReport);
